// extracted by mini-css-extract-plugin
export default {"root":"EULA_root__21Eq1","thirBlock":"EULA_thirBlock__HG6nd","document":"EULA_document__-+9ZE"};